<red-header></red-header>
<red-page-content>
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item-divider color="primary">
      <ion-label>Calculators</ion-label>
    </ion-item-divider>
    <ion-item [routerLink]="['piti']" [detail]="true">
      <ion-label color="medium">PITI</ion-label>
      <ion-icon src="/assets/svg/piti.svg" slot="start"></ion-icon>
    </ion-item>
    <ion-item [routerLink]="['affordability']" [detail]="true">
      <ion-label color="medium">Affordability</ion-label>
      <ion-icon src="/assets/svg/affordability.svg" slot="start"></ion-icon>
    </ion-item>
    <ion-item [routerLink]="['amortization']" [detail]="true">
      <ion-label color="medium">Amortization</ion-label>
      <ion-icon src="/assets/svg/amortization.svg" slot="start"></ion-icon>
    </ion-item>
  </ion-list>
</red-page-content>
